import React, { useState, useEffect } from "react";
import DocumentsCard from "./DocumentsCard";

function DocumentsList({ competitor }) {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    console.log("DocumentsList component mounted/updated with competitor:", competitor);
    
    const fetchDocuments = async () => {
      console.log("Starting fetchDocuments for competitor name:", competitor?.name);
      let responseData = null;
      
      try {
        setLoading(true);
        console.log("Making API request to /.netlify/functions/fetchDocuments");

        const token = localStorage.getItem("authToken"); // 🔹 Retrieve JWT token

        const response = await fetch("/.netlify/functions/fetchDocuments", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`, // 🔹 Include token in request
          },
          body: JSON.stringify({ competitorName: competitor.name }),
        });

        console.log("Received API response:", {
          status: response.status,
          statusText: response.statusText,
          headers: Object.fromEntries(response.headers.entries()),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        responseData = await response.json();
        console.log("Parsed API response data:", responseData);
        
        // Transform the data to match the expected format
        const formattedDocuments = responseData.map(doc => ({
          link: doc.url || doc.link,
          title: doc.title || "Untitled Document",
        })).filter(doc => Boolean(doc.link));

        console.log("Final formatted documents:", formattedDocuments);
        setDocuments(formattedDocuments);
        
      } catch (err) {
        console.error("Error in fetchDocuments:", {
          error: err,
          message: err.message,
          stack: err.stack,
          responseData,
        });
        setError("Failed to load documents");
      } finally {
        console.log("Fetch operation completed, setting loading to false");
        setLoading(false);
      }
    };

    if (competitor?.name) {
      console.log("Valid competitor name found, initiating fetch");
      fetchDocuments();
    } else {
      console.log("No valid competitor name, skipping fetch");
      setLoading(false);
    }

    return () => {
      console.log("DocumentsList component cleanup");
    };
  }, [competitor]);

  if (loading) {
    return <div className="text-center py-4">Loading documents...</div>;
  }

  if (error) {
    return <div className="text-red-500 text-center py-4">{error}</div>;
  }

  if (!documents.length) {
    return <div className="text-center py-4">No documents found</div>;
  }

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
      {documents.map(({ link, title }, index) => (
        <DocumentsCard key={index} link={link} title={title} />
      ))}
    </div>
  );
}

export default DocumentsList;
